import React from "react"
import {RouteComponentProps} from "react-router"
import {useTranslation} from "react-i18next"

import {usePeople as useItems} from "../../contexts/PersonContext"

import ItemForm from "../../components/People/Form"
import ItemView from "../../components/People/View"
import KeysList from "../../components/People/KeysList"
import PageItem from "../common/Item"
import NotFound from "../../components/People/NotFound"

interface pageProps extends RouteComponentProps<{
    id:      string;
    segment: string;
}> {}

const PagePeopleItem: React.FC<pageProps> = ({ match }) => {
    const { t }        = useTranslation()
    const { fetchItems, items} = useItems()

    const
        itemType:     string = 'Person',
        itemTypeName: string = t('people.title_item'),
        itemTypeUrl:  string = 'people'

    return (
        <PageItem
            useItems={useItems}
            fetchItems={fetchItems}
            itemId={match.params.id}
            items={items}
            itemType={itemType}
            itemTypeName={itemTypeName}
            itemTypeUrl={itemTypeUrl}
            ItemForm={ItemForm}
            ItemNotFound={NotFound}
            ItemView={ItemView}
            KeysList={KeysList}
            segment={match.params.segment}
        />
    )
}

export default PagePeopleItem